import {
  Box,
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Text,
  Spinner,
  useDisclosure
} from '@chakra-ui/react'
import paginate from 'paginate-array'
import { FC, useMemo, useState } from 'react'
import Paginate from 'react-paginate'

import useFilters from '@hook/shared/use-filters'

import UsersModal from '../Modal'
import UsersModalTableTr from './Tr'

const UsersTable: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const {
    loading,
    getUsers,
    usersQuery: fastQuery,
    data,
    rawUsers: users,
    usersLoading
  } = useFilters()

  // Perfis vêm do FiltersProvider (a view Users já pede `profiles` no getFilters)
  const profiles = data.profiles
  const [selected, setSelected] = useState<any>()

  const [page, setPage] = useState(1)

  const pagination = useMemo(() => {
    let toSearch = users

    if (fastQuery.length > 0) {
      const query = fastQuery.toLowerCase()

      toSearch = toSearch.filter((row: any) =>
        JSON.stringify(row).toLowerCase().includes(query)
      )
    }

    const arr = paginate(toSearch, page, 12)

    return arr
  }, [page, users, fastQuery])

  const handleUserEdit = (user: any) => {
    setSelected(user)
    onOpen()
  }

  const handleClose = () => {
    onClose()
    setSelected(null)
  }

  return (
    <Box px={0} py={6}>
      {usersLoading ? (
        <Flex
          h="220px"
          flexDir="column"
          alignItems="center"
          justifyContent="center"
        >
          <Spinner size="lg" color="yellow.400" mb={4} />
          <Text maxW="420px" textAlign="center">
            Obtendo usuários... aguarde!
          </Text>
        </Flex>
      ) : (
        <>
          <Table variant="simple" size="sm" mb={8}>
            <Thead>
              <Tr>
                <Th>ID</Th>
                <Th>Nome</Th>
                <Th>E-mail</Th>
                <Th>Perfil</Th>
                <Th isNumeric>Aprova alteração de Status?</Th>
                <Th>Ações</Th>
              </Tr>
            </Thead>
            <Tbody>
              {pagination.data.map((user: any, index: number) => (
                <UsersModalTableTr
                  key={`user-${index}`}
                  data={user}
                  profiles={profiles}
                  loadingProfiles={loading || profiles.length === 0}
                  onSelect={handleUserEdit}
                  onUpdate={getUsers}
                />
              ))}
            </Tbody>
          </Table>

          {users.length > 0 && (
            <Paginate
              containerClassName={'pagination'}
              activeClassName={'active'}
              pageCount={pagination.totalPages}
              forcePage={pagination.currentPage - 1}
              pageRangeDisplayed={5}
              marginPagesDisplayed={1}
              previousLabel={'Página anterior'}
              nextLabel={'Próxima página'}
              onPageChange={({ selected }: any) => {
                setPage(selected + 1)
              }}
            />
          )}
        </>
      )}
      <UsersModal
        data={selected}
        isOpen={isOpen}
        onClose={handleClose}
        onUpdate={getUsers}
      />
    </Box>
  )
}

export default UsersTable
